module.exports = __webpack_public_path__ + "img/dashboard.33d53da5.svg";